import React from "react";
import "./SpinnerComponent.scss";

const SpinnerComponent = () => {
  return <div className="loader"></div>;
};

export default SpinnerComponent;
